// extracted by mini-css-extract-plugin
module.exports = {"hidden":"tooltip_hidden__EjxUK","textEmphasis":"tooltip_textEmphasis__l7EGT","tooltipArea":"tooltip_tooltipArea__MqL3_","tooltip":"tooltip_tooltip__Lt3mk"};